/* Policy pages: builds the "On this page" index from the policy's own headings and marks the section in view.
   Navigation only; the policy text is never changed, hidden or summarized. */
(() => {
  const root = document.querySelector('.mila-policies');
  const body = root?.querySelector('.shopify-policy__body');
  if (!root || !body) return;

  const headings = [...body.querySelectorAll('h2')];
  const usedIds = new Set();
  headings.forEach((heading, index) => {
    if (!heading.id) {
      const base = (heading.textContent || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || document.getElementById(id)) id = `${base}-${suffix++}`;
      heading.id = id;
    }
    usedIds.add(heading.id);
    heading.tabIndex = -1;
  });

  root.querySelector('.mila-policies__back')?.addEventListener('click', () => root.focus({ preventScroll: true }));

  const contents = root.querySelector('[data-policy-contents]');
  const list = contents?.querySelector('[data-policy-toc]');
  if (!contents || !list || headings.length < 2) return;

  const entries = headings.map((heading) => {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
    return { heading, link };
  });

  // Open beside the policy on desktop; folded above it on phones and tablets.
  const desktop = window.matchMedia('(min-width: 990px)');
  contents.open = desktop.matches;
  contents.hidden = false;
  desktop.addEventListener('change', (event) => { contents.open = event.matches; });

  let current = -1;
  const markCurrent = (index) => {
    if (index === current) return;
    entries.forEach(({ link }, i) => {
      if (i === index) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    current = index;
  };
  let pending = false;
  const updatePosition = () => {
    const header = document.querySelector('.section-header');
    const threshold = (header?.getBoundingClientRect().height || 80) + 48;
    let index = 0;
    entries.forEach(({ heading }, i) => {
      if (heading.getBoundingClientRect().top <= threshold) index = i;
    });
    markCurrent(index);
    pending = false;
  };
  window.addEventListener('scroll', () => {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(updatePosition);
  }, { passive: true });

  entries.forEach(({ heading, link }, index) => {
    link.addEventListener('click', () => {
      // Native anchor navigation keeps browser history and works with the keyboard.
      if (!desktop.matches) contents.open = false;
      heading.focus({ preventScroll: true });
      markCurrent(index);
    });
  });

  // Heading IDs are added after load, so a shared link to a section needs one scroll here.
  if (window.location.hash) {
    const target = entries.find(({ heading }) => `#${heading.id}` === window.location.hash);
    if (target) target.heading.scrollIntoView();
  }
  updatePosition();
})();
